export default __webpack_public_path__ + "static/media/storeicon.2887abd3.svg";